import Vue from "vue";
import App from "./App.vue";

import VueCompositionAPI from '@vue/composition-api'
Vue.use(VueCompositionAPI);

import "vue-tel-input/dist/vue-tel-input.css";

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

import { createPinia, PiniaVuePlugin } from 'pinia'
Vue.use(PiniaVuePlugin);
const pinia = createPinia();

import JsonViewer from "vue-json-viewer";
Vue.use(JsonViewer);

const { detect } = require("detect-browser");
const browser = detect();

switch (browser && browser.name) {
  case "ie":
    console.log("Browser not supported");
    window.location.href = "https://www.mozilla.org/es-ES/firefox/new/";
    break;
  default:
    console.log("current browser:", browser);
    break;
}

//constants
import * as constants from "@/constants";

// axios
import axios from "./axios.js";
Vue.prototype.$http = axios;

// API Calls
import "./http/requests";

// mock
import "./fake-db/index.js";

// IndexedDB settings
import DBConfig from "./constants/IndexedDB";
import IndexedDB from "./helpers/IndexedDB";

// Theme Configurations
import "../themeConfig.js";

// Firebase
import config from "@/constants/firebase";
import firebase from "firebase/app";
// import 'firebase/app'
import "firebase/database";
import "firebase/performance";
import "firebase/storage";

// Firebase
export const firebaseInstance = firebase.initializeApp(config);

// Firebase real time database
export const db = firebase.database();

// Firebase Performance Monitoring
export const perf = firebase.performance();

// Auth0 Plugin
import AuthPlugin from "./plugins/auth";
Vue.use(AuthPlugin);

// ACL
import acl from "./acl/acl";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "@/router";

// Vuex Store
// import store from './store/store'
import store from "@/store";

// i18n
import i18n from "@/i18n";

// Vuexy Admin Filters
import "@/filters";

// Clipboard
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

// Tour
// import VueTour from 'vue-tour'
// Vue.use(VueTour)
// require('vue-tour/dist/vue-tour.css')

// VeeValidate
import VeeValidate from "vee-validate";
Vue.use(VeeValidate);

// Google Maps
const GoogleMapsApiLoader = require("google-maps-api-loader");

GoogleMapsApiLoader({
  apiKey: constants.googleMapsApiKey,
  libraries: constants.libraries
}).then(
  function (googleApi) {
    console.info("GoogleMaps Api is loading...");
    !window.google ? (window.google = googleApi) : console.info("GoogleMapsApi is loaded!");
  },
  function (err) {
    console.error("GoogleMaps Api Loader Error:", err);
  }
);

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");

import moment from "moment";
moment.updateLocale("es", {
  monthsShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]
});

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false;

// IndexedDB start
IndexedDB.init(DBConfig);

const vm = new Vue({
  router,
  store,
  i18n,
  acl,
  pinia,
  render: h => h(App)
}).$mount("#app");

import { user } from "@/provider/dataUser.js";
import login from "@/mixins/login";
//retrieve token from IndexedDB
user().then(result => {
  if (result) {
    store.commit("SET_SESSION_TOKEN", result.accessToken);
    const user = login.methods._mapUser([result]);
    vm.$acl.change(user[0].roleName.toLowerCase());
    store.commit("SET_DATA_USER", user[0]);
  }
});

export { vm };
